import { transformExtent } from "ol/proj";
export function removeFrom(list, entry) {
    return list.filter((value) => {
        return value !== entry;
    });
}
export function removeListFromList(list1, list2) {
    const unique = [...new Set(list1)];
    return list2.filter((value) => {
        return !unique.includes(value);
    });
}
export function bound(lower, value, upper) {
    return Math.max(lower, Math.min(value, upper));
}
export function unique(list) {
    const result = [];
    const map = new Map();
    for (const item of list) {
        const json = JSON.stringify(item);
        if (!map.has(json)) {
            map.set(json, true);
            result.push(item);
        }
    }
    return result;
}
export function bboxToExtent(bbox) {
    return transformExtent(bbox, "EPSG:4326", "EPSG:3857");
}
export function isSingleLocation(location) {
    return (location !== undefined &&
        location.lat !== undefined &&
        location.lon !== undefined);
}
export function carthesianProduct(array) {
    let results = [[]];
    for (let i = 0; i < array.length; i++) {
        const currentSubArray = array[i];
        const temp = [];
        for (let j = 0; j < results.length; j++) {
            for (let k = 0; k < currentSubArray.length; k++) {
                temp.push(results[j].concat(currentSubArray[k]));
            }
        }
        results = temp;
    }
    return results;
}
export function arrayContainsContent(array) {
    for (var counter = 0; counter < array.length; counter++) {
        if (array[counter] !== (null || undefined)) {
            return true;
        }
    }
    return false;
}
export function degrees2meters(lon, lat) {
    var x = lon * 20037508.34 / 180;
    var y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
    y = y * 20037508.34 / 180;
    return [x, y];
}
export function meters2degrees(coord) {
    const e_value = 2.7182818284;
    const X = 20037508.34;
    const lat3857 = coord[1];
    const long3857 = coord[0];
    const long4326 = (long3857 * 180) / X;
    let lat4326 = lat3857 / (X / 180);
    const exponent = (Math.PI / 180) * lat4326;
    lat4326 = Math.atan(Math.pow(e_value, exponent));
    lat4326 = lat4326 / (Math.PI / 360);
    lat4326 = lat4326 - 90;
    return [long4326, lat4326];
}
